import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import ImageCarousel from '../components/ImageCarousel/ImageCarousel';
import './HomePage.css';

// Import SPA Section Components
import AboutPage from './AboutPage';
import VisionMissionPage from './VisionMissionPage';

// Import all required images for the right sidebar
import founderImg from '../images/founder.jpg';
import presidentImg from '../images/president-image.jpg';
import secretaryImg from '../images/secretry-photo.jpg';
import sanjayImg from '../images/male-photo.png'; // Assuming these match the screenshots
import sameerImg from '../images/secmale-photo.png';
import principalImg from '../images/principle-photo.jpg';
import admissionBanner from '../images/admisssion-apply.png';
import ramanConference from '../images/raman-logo.jpeg';
import youtubeImg from '../images/you-tube.jpeg';
import sgbauLogo from '../images/sgb-amravti.png';

const HomePage = () => {
  return (
    <Layout>
      <div id="home" className="homepage-container">
        <div className="homepage-grid">
          
          {/* Left Sidebar */}
          <aside className="left-sidebar">
            <div className="sidebar-section">
              <h3 className="sidebar-title">Admission</h3>
              <ul className="sidebar-list">
                <li><Link to="/vacancy-of-2026" className="sidebar-link">Vacancy of 2026</Link></li>
                <li><Link to="/admission-brochure">Admission Brochure</Link></li>
                <li><Link to="/admission-form">Admission Form</Link></li>
                <li><Link to="/student-admission-list">Year wise Student Admission List</Link></li>
              </ul>
            </div>
            
            <div className="sidebar-section">
              <h3 className="sidebar-title">Feedback Forms</h3>
              <ul className="sidebar-list">
                <li><Link to="/alumni-feedback">Alumni Feedback</Link></li>
                <li><Link to="/teacher-feedback">Teacher Feedback</Link></li>
                <li><Link to="/student-feedback">Student Feedback</Link></li>
              </ul>
            </div>

            <div className="sidebar-section">
              <h3 className="sidebar-title">More Information</h3>
              <ul className="sidebar-list">
                <li><Link to="/academic-calendar">Academic Calendar</Link></li>
                <li><Link to="/rules-regulations">Rules & Regulations</Link></li>
                <li><Link to="/syllabus">Syllabus</Link></li>
                <li><Link to="/anti-ragging">Anti Ragging</Link></li>
                <li><Link to="/women-cell">Women Cell</Link></li>
                <li><Link to="/grievance">Grievance & Redressal Committee</Link></li>
                <li><Link to="/student-council">Student Council</Link></li>
                <li><Link to="/scholarships">Scholarships & Awards</Link></li>
              </ul>
            </div>
          </aside>

          {/* Center Content - SPA Mastery container */}
          <section className="center-content">
            <ImageCarousel />
            
            {/* Render all sections sequentially */}
            <AboutPage />
            <VisionMissionPage />

          </section>

          {/* Right Sidebar */}
          <aside className="right-sidebar">
            
            {/* Founder Card */}
            <div className="profile-card founder-card">
              <img src={founderImg} alt="Founder" className="profile-img-large" />
              <h4>Late Shri Govindrao Sitaramji Tompe G founder</h4>
            </div>

            {/* Management Grid */}
            <div className="management-grid">
              <div className="mgmt-card">
                <img src={presidentImg} alt="President" className="mgmt-img" />
                <p>Hon Shri Bhaskardada K Tompe<br/>President</p>
              </div>
              <div className="mgmt-card">
                <img src={secretaryImg} alt="Secretary" className="mgmt-img" />
                <p>Hon Dr Vijay K Tompe<br/>Secretary</p>
              </div>
              <div className="mgmt-card">
                <img src={sanjayImg} alt="Late Sanjay Tompe" className="mgmt-img" />
                <p>Late Sanjay Tompe</p>
              </div>
              <div className="mgmt-card">
                <img src={sameerImg} alt="Late Sameer deshmukh" className="mgmt-img" />
                <p>Late Sameer deshmukh</p>
              </div>
            </div>

            {/* Principal's Desk */}
            <div className="principal-desk-card">
              <h3 className="desk-title">From<br/>Principal's<br/>Desk</h3>
              <img src={principalImg} alt="Principal" className="profile-img-large" />
              <h4 className="principal-name">Prof. Sanjay R. Shejao</h4>
              <p className="principal-role">Principal, Late Sanjay Tompe & Late Sameer Deshmukh B.Ed College</p>
              <a href="#message" className="btn-read-message">Read The Message</a>
            </div>

            {/* Banners */}
            <div className="sidebar-banner admission-banner">
              <img src={admissionBanner} alt="Admission Open" style={{ width: '100%', borderRadius: '8px' }} />
              <p className="banner-text">Apply for<br/>ADMISSION !</p>
            </div>

            <div className="sidebar-banner conference-banner">
              <img src={ramanConference} alt="Raman 2022 Conference" style={{ width: '100%', borderRadius: '8px' }} />
              <p className="banner-text">2<sup>nd</sup> INTERNATIONAL<br/>CONFERENCE<br/>RAMAN 2022</p>
            </div>

            <div className="sidebar-banner youtube-banner">
              <h4 className="youtube-title">G.S. Tompe Arts,<br/>Commerce & Science<br/>College</h4>
              <img src={youtubeImg} alt="YouTube Video" style={{ width: '100%', borderRadius: '8px', marginBottom: '10px' }} />
              <p className="youtube-desc">This video is age-restricted and only available on YouTube. Learn more</p>
            </div>

          </aside>

        </div>
      </div>
    </Layout>
  );
};

export default HomePage;